<template>
    <div class="my-quotation-doubao">
        <!-- Gradient Mesh Hero -->
        <div class="mesh-hero">
            <h3 class="hero-title">抖包双搜在线询价</h3>
        </div>

        <div class="quotation-content" v-if="!showForm">
            <!-- Form Card -->
            <div class="form-card">
                <van-cell @click="showCategory = true" title="选择行业" :value="categoryDesc || '请选择行业'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <van-cell @click="showCity = true" title="投放城市" :value="cityDesc || '请选择投放城市'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <van-cell @click="showDuration = true" title="服务时长" :value="mathParams.duration || '请选择服务时长'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
                <van-cell @click="showWordCount = true" title="词根数量" :value="mathParams.wordCount || '请选择词根数量'" class="select-cell" :border="false" is-link clickable title-style="max-width: 70px;" />
            </div>

            <div class="button-group">
                <button class="btn-primary-pill" @click="submitMathPrice">查询报价</button>
            </div>

            <!-- 询价错误 -->
            <div class="result-error" v-if="mathError">
                {{ mathError }}
            </div>

            <!-- 询价结果 -->
            <div class="result-card" v-else-if="mathResult.price">
                <div class="result-label-row">
                    <span class="result-label">询价结果</span>
                    <span class="result-tag" v-if="mathResult.usePriceType == specialOfferPriceType">{{ mathResult.specialOfferTypeTitle || "直通车" }}</span>
                    <span class="result-tag" v-else-if="mathResult.usePriceType == activityPriceType">{{ mathResult.activityTitle || "活动优惠" }}</span>
                </div>
                <div class="result-price-row">
                    <template v-if="mathResult.showPrice">
                        <span class="result-original">￥{{ mathResult.price }}</span>
                    </template>
                    <span class="result-final">￥{{ mathResult.payPrice }}</span>
                </div>
            </div>
        </div>

        <!-- 行业三级分类选择 -->
        <van-popup v-model="showCategory" position="bottom" round :style="{ height: '60%' }">
            <van-picker ref="categoryPicker" title="选择行业" show-toolbar :columns="showCategoryList" @change="changeCategory" @confirm="confirmCategory" @cancel="cancelCategory">
                <template #columns-top>
                    <div class="category-search-box">
                        <van-field v-model="categoryKeyword" placeholder="输入行业关键字" clearable @input="onCategoryKeywordInput" left-icon="search" />
                    </div>
                </template>
            </van-picker>
        </van-popup>

        <!-- 城市选择 -->
        <van-popup v-model="showCity" position="bottom" round :style="{ height: '60%' }">
            <van-picker ref="cityPicker" title="投放城市" show-toolbar :columns="showCityList" @change="changeCity" @confirm="confirmCity" @cancel="showCity = false">
                <template #columns-top>
                    <div class="category-search-box">
                        <van-field v-model="cityKeyword" placeholder="输入城市关键字" clearable @input="onCityKeywordInput" left-icon="search" />
                    </div>
                </template>
            </van-picker>
        </van-popup>

        <!-- 服务时长选择 -->
        <van-popup v-model="showDuration" position="bottom" round>
            <van-picker show-toolbar title="服务时长" :columns="showDurationList" @confirm="confirmDuration" @cancel="showDuration = false" />
        </van-popup>

        <!-- 词根数量选择 -->
        <van-popup v-model="showWordCount" position="bottom" round>
            <van-picker show-toolbar title="词根数量" :columns="showWordCountList" @confirm="confirmWordCount" @cancel="showWordCount = false" />
        </van-popup>



        <!-- 校验码输入 -->
        <van-dialog v-model="showForm" :before-close="beforeCloseInputPhoneDialog" title="请输入询价校验码" style="padding: 0 12px" theme="round-button">
            <div class="logo-img">
                <div style="padding-top: 150px">
                    <span class="logo-title">抖包双搜在线询价</span>
                </div>
            </div>
            <van-field ref="codeField" v-model="code" placeholder="请输入校验码,点击确认后查看询价" />
        </van-dialog>

        <van-overlay :show="!loadReady">
            <van-loading type="spinner" color="#1989fa" />
        </van-overlay>
    </div>
</template>

<script>
import { getBrowserKeyAsync } from "@/utils/browserUtil";
import {
    verifyCode,
    getConfigInfo,
    mathPriceInfo,
    getCityList,
    getSubCategoryList,
    getSubSubCategoryList,
    searchCategoryIncludeSubCategory,
    searchProvinceIncludeCity
} from "@/api/quotationDouBao";

const specialOfferPriceType = 1;
const activityPriceType = 5;

const allProvinceLabel = "全国";
const allCityLabel = "所有地区";

export default {
    name: "QuotationDouBao",
    components: {},
    data() {
        return {
            loadReady: false,
            showForm: false,
            code: "",
            config: {
                provinceList: [],
                cityList: [],
                categoryList: [],
                subCategoryList: [],
                durationList: [],
                wordCountList: [],
            },
            categoryKeyword: '',
            cityKeyword: '',
            showCategoryList: [],
            showCityList: [],
            showCategory: false,
            showCity: false,
            showDuration: false,
            showWordCount: false,
            // 询价参数
            mathParams: {
                code: "",
                province: "",
                city: "",
                category: "",
                subCategory: "",
                subSubCategory: "",
                duration: "",
                wordCount: "",
            },
            // 询价结果
            mathResult: {
                price: "",
                payPrice: "暂无报价",
                showPrice: false,
                usePriceType: 0,
                specialOfferTypeTitle: "",
                activityTitle: "",
            },
            // 询价错误信息
            mathError: "",
            specialOfferPriceType,
            activityPriceType,
        };
    },
    computed: {
        // 行业描述(三级)
        categoryDesc() {
            if (!this.mathParams.category) {
                return "";
            }
            let desc = this.mathParams.category;
            if (this.mathParams.subCategory) {
                desc += " - " + this.mathParams.subCategory;
            }
            if (this.mathParams.subSubCategory) {
                desc += " - " + this.mathParams.subSubCategory;
            }
            return desc;
        },
        // 城市描述
        cityDesc() {
            if (!this.mathParams.province) {
                return "";
            }
            return this.mathParams.province + (this.mathParams.city && this.mathParams.city !== allCityLabel ? " - " + this.mathParams.city : "");
        },
        // 服务时长列表
        showDurationList() {
            return this.config.durationList || [];
        },
        // 词根数量列表
        showWordCountList() {
            return this.config.wordCountList || [];
        },
    },
    watch: {
        // 监听询价参数变动，重置结果与错误
        mathParams: {
            handler() {
                this.resetMathResult();
            },
            deep: true,
        },
        // 行业弹窗打开时，检查当前一级分类是否已加载二级数据
        showCategory(val) {
            if (!val) return;
            this.$nextTick(() => {
                var picker = this.$refs.categoryPicker;
                if (!picker) return;
                var firstColumnIndex = picker.getColumnIndex(0);
                var cache = this._categoryCache || {};
                var category = (picker.getColumnValue(0) || {}).text;
                if (!category) return;
                var cachedParent = cache[firstColumnIndex] ? cache[firstColumnIndex].loadedCategory : undefined;
                if (cachedParent !== category) {
                    this.loadSubCategory(category, firstColumnIndex, picker);
                }
            });
        },
        // 城市弹窗打开时，检查当前省份是否已加载城市数据
        showCity(val) {
            if (!val) return;
            this.$nextTick(() => {
                var picker = this.$refs.cityPicker;
                if (!picker) return;
                var province = (picker.getColumnValue(0) || {}).text;
                if (!province) return;
                // 检查该省份的城市数据是否已缓存
                if (!this._cityDataCache || !this._cityDataCache[province]) {
                    this.loadCityForPicker(province, picker);
                }
            });
        },
    },
    created() {
        this.init();
        this.addEnterEvent(this.handleSubmit.bind(this), "inputCodeSubmit");
        document.querySelector("body").setAttribute("style", "background-color:#f6f9fc");
        window.qtn = this;
    },
    destroyed() {
        this.delEnterEvent("inputCodeSubmit");
    },
    beforeRouteLeave(to, from, next) {
        return this.callBackEvent().then(
            () => next(),
            (e) => next(false)
        );
    },
    methods: {
        // 初始化数据
        init() {
            this.changeFavicon("/static/img/quotation.ico");

            var that = this,
                code = (that.code = this.$route.query.code || "");
            if (code) {
                that.setLoad(() => {
                    return getBrowserKeyAsync().then(that.initConfigInfo);
                }).catch(that.showInputPhoneDialog);
            } else {
                that.loadReady = true;
                that.showInputPhoneDialog();
            }
        },
        // 初始化询价信息
        initConfigInfo() {
            var that = this,
                code = that.code;
            if (!code) {
                return Promise.reject("请输入有效的校验码");
            }
            return getConfigInfo(that.code)
                .then((res) => {
                    var configObj = res?.data || {};
                    that.$set(that, "config", configObj);
                    that.mathParams.code = that.code;
                    that.showCategoryList.splice(0);
                    that.showCityList.splice(0);

                    // 初始化行业分类(三级)
                    that._subCategoryDataCache = {};
                    that._subSubCategoryDataCache = {};
                    (configObj.categoryList || []).forEach((p, pi) => {
                        let obj = {
                            text: p,
                            children: [{ text: "" }],
                        };
                        if (pi === 0) {
                            // 预缓存第一个一级分类的二级数据
                            var firstSubList = (configObj.subCategoryList || []).map((c) => ({ text: c, children: [{ text: "" }] }));
                            that._subCategoryDataCache[p] = firstSubList;
                            obj.children = firstSubList;
                            // 预缓存第一个二级分类的三级数据
                            if (firstSubList.length > 0) {
                                var firstSubSubList = (configObj.subSubCategoryList || []).map((sc) => ({ text: sc }));
                                that._subSubCategoryDataCache[p + '|' + firstSubList[0].text] = firstSubSubList;
                                firstSubList[0].children = firstSubSubList;
                            }
                        }
                        that.showCategoryList.push(obj);
                    });

                    // 初始化城市列表
                    that._cityDataCache = {};
                    (configObj.provinceList || []).forEach((p, pi) => {
                        let obj = {
                            text: p,
                            children: [{ text: allCityLabel }],
                            load: false,
                        };
                        if (pi === 0) {
                            obj.children = (configObj.cityList || []).map((c) => ({ text: c }));
                            obj.load = true;
                            // 缓存第一个省份的城市数据
                            that._cityDataCache[p] = (configObj.cityList || []).map((c) => ({ text: c }));
                        }
                        that.showCityList.push(obj);
                    });

                    // 如果只有一个省份,自动选择
                    if (that.showCityList && that.showCityList.length == 1) {
                        this.mathParams.province = that.showCityList[0].text;
                        this.loadCityList(this.mathParams.province).then((list) => {
                            if (list && list.length > 0) {
                                this.mathParams.city = list.includes(allCityLabel) ? allCityLabel : list[0];
                            }
                        });
                    }
                })
                .catch((e) => {
                    that.$msg.error(e || "获取抖包询价配置信息失败");
                    return Promise.reject(e);
                });
        },
        // 回车提交
        handleSubmit(e) {
            if (this.showForm) {
                if (!this.code) {
                    return this.$msg.error("请输入有效的校验码");
                }
                return this.beforeCloseInputPhoneDialog("confirm", () => {});
            } else {
                var that = this;
                if (!that.mathParams.code) {
                    return that.$msg.error("请输入有效的校验码");
                }
                // 如果有任何弹框正在显示，则不执行价格计算
                if (that.showCategory || that.showCity || that.showWordCount || that.showDuration) {
                    return;
                }
                return that.submitMathPrice();
            }
        },
        // 关闭校验码弹框
        beforeCloseInputPhoneDialog(action, done) {
            if (action === "confirm") {
                this.code = (this.code || "").trim();
                if (!this.code) {
                    this.$msg("请输入有效的校验码");
                    done(false);
                } else {
                    this.initConfigInfo().then(
                        () => {
                            this.showForm = false;
                            done();
                        },
                        (e) => {
                            console.log("initConfigInfo", e);
                            done(false);
                        }
                    );
                }
            } else {
                done(false);
            }
        },
        // 显示校验码输入框
        showInputPhoneDialog() {
            this.showForm = true;
            this.$nextTick(() => {
                if (this.$refs.codeField) {
                    this.$refs.codeField.focus();
                    setTimeout(() => {
                        if (this.$refs.codeField) {
                            this.$refs.codeField.focus();
                        }
                    }, 3000);
                }
            });
        },

        // 选择行业(三级联动)
        changeCategory(picker, valList, index) {
            var that = this;
            console.log("changeCategory", valList, index);
            // 选中一级分类时,加载二级
            if (index === 0) {
                var category = valList[0];
                if (!category) return;
                var firstColumnIndex = picker.getColumnIndex(0);
                // 判断二级是否需要重新加载：未加载过(只有占位符) 或 当前二级数据不属于该一级分类
                var col1Values = picker.getColumnValues(1) || [];
                var needReload = col1Values.length <= 1;
                if (!needReload) {
                    // 从独立缓存对象读取（不触碰showCategoryList避免触发vant重渲染）
                    var cache = that._categoryCache || {};
                    var cachedParent = cache[firstColumnIndex] ? cache[firstColumnIndex].loadedCategory : undefined;
                    needReload = cachedParent !== category;
                }
                if (needReload) {
                    that.loadSubCategory(category, firstColumnIndex, picker);
                }
            }
            // 选中二级分类时,加载三级
            if (index === 1) {
                var subCategory = valList[1];
                // 过滤空占位符，避免用空字符串调API
                if (!subCategory) return;
                // vant级联Picker滚动column1时会触发多次change事件（column1变化+column2级联更新）
                // 用$nextTick合并连续事件，取最终稳定状态加载三级
                that._pendingSubLoad = { subCategory: subCategory, firstValue: valList[0] };
                if (!that._pendingSubLoadScheduled) {
                    that._pendingSubLoadScheduled = true;
                    that.$nextTick(() => {
                        that._pendingSubLoadScheduled = false;
                        var pending = that._pendingSubLoad;
                        if (!pending) return;
                        that._pendingSubLoad = null;
                        // 从picker读取最终稳定状态
                        var currentSub = picker.getColumnValue(1);
                        var finalSub = currentSub ? (currentSub.text || currentSub) : pending.subCategory;
                        if (!finalSub) return;
                        var currentCat = picker.getColumnValue(0);
                        var finalCat = currentCat ? (currentCat.text || currentCat) : pending.firstValue;
                        var secondColumnIndex = picker.getColumnIndex(1);
                        // 从独立缓存对象读取
                        var cache = that._categoryCache || {};
                        var col0Idx = picker.getColumnIndex(0);
                        var cachedSub = cache[col0Idx] ? cache[col0Idx].loadedSubCategory : undefined;
                        if (cachedSub !== finalSub) {
                            that.loadSubSubCategory(finalCat, finalSub, secondColumnIndex, picker);
                        }
                    });
                }
            }
        },
        // 加载二级分类
        loadSubCategory(category, firstColumnIndex, picker) {
            var that = this;
            if (!that._subCategoryDataCache) that._subCategoryDataCache = {};
            // 已有缓存，直接显示
            if (that._subCategoryDataCache[category]) {
                var cachedList = that._subCategoryDataCache[category];
                if (picker && (picker.getColumnValue(0) || {}).text == category) {
                    picker.setColumnValues(1, cachedList);
                    picker.setColumnValues(2, [{ text: "" }]);
                    // 缓存标记
                    if (!that._categoryCache) that._categoryCache = {};
                    if (!that._categoryCache[firstColumnIndex]) that._categoryCache[firstColumnIndex] = {};
                    that._categoryCache[firstColumnIndex].loadedCategory = category;
                    that._categoryCache[firstColumnIndex].loadedSubCategory = cachedList[0].text;
                    // 自动加载第一项的三级分类
                    that.$nextTick(() => {
                        that.loadSubSubCategory(category, cachedList[0].text, 0, picker);
                    });
                }
                return Promise.resolve(cachedList);
            }
            return getSubCategoryList(that.code, category)
                .then((res) => {
                    var list = ((res || {}).data || []).map((text) => ({ text, children: [{ text: "" }] }));
                    if (list.length > 0) {
                        // 始终缓存（不丢弃，确保每个一级分类只请求一次）
                        that._subCategoryDataCache[category] = list;
                        // picker打开时不修改showCategoryList（避免Vue响应式触发vant重新渲染）
                        if (that.showCategory) {
                            if (!that._pendingCategoryChildren) that._pendingCategoryChildren = {};
                            that._pendingCategoryChildren[firstColumnIndex] = list;
                        } else {
                            that.showCategoryList[firstColumnIndex].children.splice(0);
                            list.forEach((item) => that.showCategoryList[firstColumnIndex].children.push(item));
                        }
                        // 缓存标记
                        if (!that._categoryCache) that._categoryCache = {};
                        if (!that._categoryCache[firstColumnIndex]) that._categoryCache[firstColumnIndex] = {};
                        that._categoryCache[firstColumnIndex].loadedCategory = category;
                        // 仅在picker当前选中项匹配时才设置显示
                        if (picker && (picker.getColumnValue(0) || {}).text == category) {
                            picker.setColumnValues(1, list);
                            picker.setColumnValues(2, [{ text: "" }]);
                            that._categoryCache[firstColumnIndex].loadedSubCategory = list[0].text;
                            that.$nextTick(() => {
                                that.loadSubSubCategory(category, list[0].text, 0, picker);
                            });
                        }
                        return list;
                    } else {
                        return Promise.reject("获取子行业失败");
                    }
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取子行业失败");
                    that.showCategory = false;
                    return [];
                });
        },
        // picker关闭时将缓存的二级分类数据同步到showCategoryList
        syncCategoryList() {
            if (!this._pendingCategoryChildren) return;
            var pending = this._pendingCategoryChildren;
            this._pendingCategoryChildren = null;
            Object.keys(pending).forEach((idx) => {
                var i = parseInt(idx);
                var list = pending[idx];
                if (this.showCategoryList[i]) {
                    this.showCategoryList[i].children.splice(0);
                    list.forEach((item) => this.showCategoryList[i].children.push(item));
                }
            });
        },
        // 取消行业选择
        cancelCategory() {
            this.syncCategoryList();
            this.showCategory = false;
        },
        // 加载三级分类
        loadSubSubCategory(category, subCategory, secondColumnIndex, picker) {
            var that = this;
            // 防御空参数
            if (!category || !subCategory) {
                return Promise.resolve([]);
            }
            var cacheKey = category + '|' + subCategory;
            if (!that._subSubCategoryDataCache) that._subSubCategoryDataCache = {};
            // 已有缓存，直接显示
            if (that._subSubCategoryDataCache[cacheKey]) {
                var cachedList = that._subSubCategoryDataCache[cacheKey];
                if (picker) {
                    var currentCat = (picker.getColumnValue(0) || {}).text;
                    var currentSub = (picker.getColumnValue(1) || {}).text;
                    if (currentCat == category && currentSub == subCategory) {
                        picker.setColumnValues(2, cachedList);
                        if (cachedList.length === 1) {
                            that.$nextTick(() => {
                                try { picker.setColumnIndex(2, 0); } catch (e) {}
                            });
                        }
                    }
                }
                return Promise.resolve(cachedList);
            }
            return getSubSubCategoryList(that.code, category, subCategory)
                .then((res) => {
                    var list = ((res || {}).data || []).map((text) => ({ text }));
                    // 始终缓存（不丢弃，确保每组category+subCategory只请求一次）
                    that._subSubCategoryDataCache[cacheKey] = list;
                    if (list.length > 0) {
                        if (picker) {
                            // 仅在picker当前选中项匹配时才设置显示
                            var currentCat = (picker.getColumnValue(0) || {}).text;
                            var currentSub = (picker.getColumnValue(1) || {}).text;
                            if (currentCat == category && currentSub == subCategory) {
                                picker.setColumnValues(2, list);
                                // 缓存标记
                                var firstIdx = picker.getColumnIndex(0);
                                if (firstIdx >= 0) {
                                    if (!that._categoryCache) that._categoryCache = {};
                                    if (!that._categoryCache[firstIdx]) that._categoryCache[firstIdx] = {};
                                    that._categoryCache[firstIdx].loadedSubCategory = subCategory;
                                }
                                // 如果只有一个三级分类，自动选中
                                if (list.length === 1) {
                                    that.$nextTick(() => {
                                        try { picker.setColumnIndex(2, 0); } catch (e) {}
                                    });
                                }
                            }
                        }
                        return list;
                    } else {
                        return [];
                    }
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取三级行业失败");
                    return [];
                });
        },
        // 行业关键字搜索
        onCategoryKeywordInput(keyword) {
            if (!keyword || !keyword.trim()) return;
            var that = this;
            that.throttleCall('searchCategoryIncludeSubCategory', () => {
                searchCategoryIncludeSubCategory(that.code, keyword.trim()).then((res) => {
                    var categoryList = (res || {}).data || [];
                    if (!categoryList.length) return;
                    var firstCategory = categoryList[0];
                    var picker = that.$refs.categoryPicker;
                    if (!picker) return;
                    var colIndex = that.showCategoryList.findIndex((item) => item.text === firstCategory);
                    if (colIndex < 0) return;
                    // 选中一级分类
                    picker.setColumnIndex(0, colIndex);
                    // 加载二级分类
                    that.loadSubCategory(firstCategory, colIndex, picker).then((subList) => {
                        if (!subList || !subList.length) return;
                        // 查找二级分类中是否有包含关键字的项
                        var matchIndex = subList.findIndex((item) => item.text && item.text.includes(keyword.trim()));
                        if (matchIndex >= 0) {
                            picker.setColumnIndex(1, matchIndex);
                        } else {
                            picker.setColumnIndex(1, 0);
                        }
                        // 加载三级分类并选中第一项
                        var selectedSub = (matchIndex >= 0 ? subList[matchIndex] : subList[0]);
                        if (selectedSub) {
                            that.$nextTick(() => {
                                that.loadSubSubCategory(firstCategory, selectedSub.text, 0, picker);
                            });
                        }
                    });
                });
            }, 2000, 0);
        },
        // 确认行业选择
        confirmCategory(valList, indexList) {
            if (valList && valList.length >= 2 && valList[0] && valList[1]) {
                this.mathParams.category = valList[0];
                this.mathParams.subCategory = valList[1];
                // 三级分类可选
                if (valList[2]) {
                    this.mathParams.subSubCategory = valList[2];
                } else {
                    this.mathParams.subSubCategory = "";
                }
            }
            this.syncCategoryList();
            this.showCategory = false;
        },

        // 选择城市
        changeCity(picker, valList, index) {
            if (index === 0) {
                var that = this,
                    province = valList[0];
                if (!province) return;
                // 检查该省份的城市数据是否已缓存
                if (!that._cityDataCache || !that._cityDataCache[province]) {
                    that.loadCityForPicker(province, picker);
                } else {
                    // 已有缓存，直接显示
                    picker.setColumnValues(1, that._cityDataCache[province]);
                }
            }
        },
        // 加载城市列表到picker
        loadCityForPicker(province, picker) {
            var that = this;
            if (!that._cityDataCache) that._cityDataCache = {};
            // 已有缓存，直接显示，不发请求
            if (that._cityDataCache[province]) {
                if (picker && (picker.getColumnValue(0) || {}).text == province) {
                    picker.setColumnValues(1, that._cityDataCache[province]);
                }
                return Promise.resolve(that._cityDataCache[province].map(function(item) { return item.text; }));
            }
            return that.getProvinceCityList(province)
                .then((cityTextList) => {
                    var list = cityTextList.map((text) => (typeof text === 'string' ? { text } : text));
                    // 始终缓存该省份的城市数据（不丢弃，确保每个省份只请求一次）
                    that._cityDataCache[province] = list;
                    // 仅在picker当前选中省份匹配时才设置显示
                    if (picker && (picker.getColumnValue(0) || {}).text == province) {
                        picker.setColumnValues(1, list);
                    }
                    return cityTextList;
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取市区失败");
                    return [];
                });
        },
        // 城市关键字搜索
        onCityKeywordInput(keyword) {
            if (!keyword || !keyword.trim()) return;
            var that = this;
            that.throttleCall('searchProvinceIncludeCity', () => {
                searchProvinceIncludeCity(that.code, keyword.trim()).then((res) => {
                    var provinceList = (res || {}).data || [];
                    if (!provinceList.length) return;
                    var firstProvince = provinceList[0];
                    var picker = that.$refs.cityPicker;
                    if (!picker) return;
                    // 找到省份对应的索引
                    var colIndex = that.showCityList.findIndex((item) => item.text === firstProvince);
                    if (colIndex < 0) return;
                    // 选中省份
                    picker.setColumnIndex(0, colIndex);
                    // 加载城市列表
                    that.loadCityForPicker(firstProvince, picker).then((cityList) => {
                        if (!cityList || !cityList.length) return;
                        // 查找城市中是否有包含关键字的项
                        var matchIndex = cityList.findIndex((item) => {
                            var text = typeof item === 'string' ? item : item.text;
                            return text && text.includes(keyword.trim());
                        });
                        if (matchIndex >= 0) {
                            picker.setColumnIndex(1, matchIndex);
                        } else {
                            picker.setColumnIndex(1, 0);
                        }
                    });
                });
            }, 2000, 0);
        },
        // 获取省市列表
        getProvinceCityList(province) {
            var that = this;
            if (!province) {
                return Promise.reject("请选择省份");
            }
            return getCityList(that.code, province)
                .then((res) => {
                    var list = (res || {}).data || [];
                    if (list.length > 0) {
                        return list;
                    } else {
                        return Promise.reject("获取市区失败");
                    }
                })
                .catch((e) => {
                    console.log(e);
                    that.$msg.error(e || "获取市区失败");
                    return [];
                });
        },
        // 加载城市列表
        loadCityList(province) {
            return this.getProvinceCityList(province);
        },
        // 确认城市选择
        confirmCity(valList, indexList) {
            if (valList && valList.length == 2 && valList[0] && valList[1]) {
                this.mathParams.province = valList[0];
                this.mathParams.city = valList[1];
            }
            this.showCity = false;
        },

        // 确认服务时长
        confirmDuration(val) {
            this.mathParams.duration = val;
            this.showDuration = false;
        },

        // 确认词根数量
        confirmWordCount(val) {
            this.mathParams.wordCount = val;
            this.showWordCount = false;
        },

        // 重置询价结果与错误信息（已为空则跳过）
        resetMathResult() {
            if (!this.mathError && !this.mathResult.price) return;
            this.mathError = "";
            this.mathResult = {
                price: "",
                payPrice: "暂无报价",
                showPrice: false,
                usePriceType: 0,
                specialOfferTypeTitle: "",
                activityTitle: "",
            };
        },

        // 提交询价
        submitMathPrice() {
            var that = this;
            if (!that.mathParams.category) {
                return that.$msg.error("请选择行业");
            }
            if (!that.mathParams.province) {
                return that.$msg.error("请选择省份");
            }
            if (!that.mathParams.duration) {
                return that.$msg.error("请选择服务时长");
            }
            if (!that.mathParams.wordCount) {
                return that.$msg.error("请选择词根数量");
            }

            // 清空之前的结果
            that.resetMathResult();

            var postData = {
                code: that.mathParams.code,
                category: that.mathParams.category,
                subCategory: that.mathParams.subCategory,
                subSubCategory: that.mathParams.subSubCategory,
                province: that.mathParams.province,
                city: that.mathParams.city,
                duration: that.mathParams.duration,
                wordCount: that.mathParams.wordCount,
            };

            return mathPriceInfo(postData)
                .then((res) => {
                    var result = res?.data || {};
                    if (!result.payPrice) {
                        var errorMsg = "暂无报价，请咨询服务商";
                        that.$msg.error(errorMsg);
                        that.mathError = errorMsg;
                        return;
                    }
                    that.$set(that, "mathResult", {
                        price: result.price || "",
                        payPrice: result.payPrice || "暂无报价",
                        showPrice: result.showPrice || false,
                        usePriceType: result.usePriceType || 0,
                        specialOfferTypeTitle: result.specialOfferTypeTitle || "",
                        activityTitle: result.activityTitle || "",
                    });
                })
                .catch((e) => {
                    var errorMsg = (e || "询价失败").toString().replace(/^Error:\s*/i, "");
                    that.$msg.error(errorMsg);
                    that.mathError = errorMsg;
                });
        },

        // 设置加载状态
        setLoad(pe) {
            var that = this,
                nextPe = pe;
            if (Promise.isPromise(pe)) {
                nextPe = () => pe;
            }
            that.loadReady = false;
            if (!that.retPe) {
                that.retPe = Promise.resolve(true);
            }
            that.retPe = that.retPe
                .then(() => {
                    that.loadReady = false;
                })
                .then(nextPe)
                .finally(() => {
                    that.loadReady = true;
                });
            return that.retPe;
        },
    },
};
</script>

<style scoped>
/* ============================================================
   DESIGN TOKENS (Stripe-inspired — DESIGN.md)
   ============================================================ */
/*  Colors
    primary:       #533afd   ink:           #0d253d
    primary-deep:  #4434d4   ink-mute:      #64748d
    primary-press: #2e2b8c   canvas:        #ffffff
    ruby:          #ea2261   canvas-soft:   #f6f9fc
    on-primary:    #ffffff   hairline:      #e3e8ee
    brand-dark:    #1c1e54   hairline-input:#a8c3de
    shadow-blue:   rgba(0,55,112,0.08)
*/

/* ============================================================
   BASE
   ============================================================ */
.my-quotation-doubao {
    font-family: Inter, "SF Pro Display", system-ui, -apple-system, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: "ss01";
    color: #0d253d;
    background-color: #f6f9fc;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.4;
    padding: 0;
    margin: 0;
    width: 100%;
    min-height: 100dvh;
    position: relative;
}

/* ============================================================
   GRADIENT MESH HERO  — brand signature atmospheric backdrop
   ============================================================ */
.mesh-hero {
    position: relative;
    padding: 48px 24px 56px;
    text-align: center;
    /* 浓烈渐变网格 */
    background: linear-gradient(135deg,
        #ff9a56 0%,
        #f759ab 25%,
        #7c3aed 50%,
        #5b21b6 75%,
        #dc2626 100%
    );
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(124, 58, 237, 0.3), 0 4px 12px rgba(220, 38, 38, 0.2);
}

.mesh-hero::after {
    content: "";
    position: absolute;
    inset: 0;
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
}

.hero-title {
    position: relative;
    z-index: 1;
    margin: 0;
    font-size: 26px;
    font-weight: 300;
    line-height: 1.12;
    letter-spacing: -0.26px;
    color: #ffffff;
    text-shadow: 0 1px 8px rgba(0,0,0,0.15);
}

/* ============================================================
   CONTENT CONTAINER
   ============================================================ */
.quotation-content {
    position: relative;
    z-index: 1;
    padding: 16px;
    margin: -24px auto 0;
    max-width: 768px;
}

/* ============================================================
   FORM CARD — card-feature-light
   ============================================================ */
.form-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
    box-shadow: rgba(0,55,112,0.08) 0 1px 3px;
    overflow: hidden;
}

/* ============================================================
   SELECT CELLS — van-cell overrides
   ============================================================ */
.my-quotation-doubao /deep/ .select-cell {
    border-bottom: 1px solid #e3e8ee;
}
.my-quotation-doubao /deep/ .select-cell:last-child {
    border-bottom: none;
}
.my-quotation-doubao /deep/ .select-cell .van-cell__title {
    font-weight: 400;
    font-size: 14px;
    color: #64748d;
    letter-spacing: -0.42px;
}
.my-quotation-doubao /deep/ .select-cell .van-cell__value {
    font-weight: 300;
    font-size: 15px;
    color: #0d253d;
    letter-spacing: 0;
}

/* ============================================================
   BUTTON — button-primary-pill
   ============================================================ */
.button-group {
    margin-top: 16px;
    display: flex;
    justify-content: center;
}

.btn-primary-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 48px;
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
    color: #ffffff;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.0;
    letter-spacing: 0;
    font-feature-settings: "ss01";
    border: none;
    border-radius: 9999px;
    padding: 8px 16px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(109, 40, 217, 0.25), 0 1px 3px rgba(109, 40, 217, 0.15);
    transition: all 0.2s ease;
}
.btn-primary-pill:active {
    transform: translateY(1px);
    box-shadow: 0 1px 4px rgba(109, 40, 217, 0.2);
}

/* ============================================================
   RESULT ERROR
   ============================================================ */
.result-error {
    box-sizing: border-box;
    width: 100%;
    background: #ffffff;
    border: 1px solid #ea2261;
    border-radius: 12px;
    padding: 12px 16px;
    margin-top: 16px;
    color: #ea2261;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    box-shadow: rgba(0,55,112,0.08) 0 1px 3px;
}

/* ============================================================
   RESULT CARD — card-pricing inspired
   ============================================================ */
.result-card {
    box-sizing: border-box;
    width: 100%;
    background: linear-gradient(145deg, #ffffff 0%, #f8f7ff 100%);
    border: 1px solid rgba(124, 58, 237, 0.15);
    border-radius: 16px;
    padding: 24px;
    margin-top: 16px;
    box-shadow: 0 4px 20px rgba(109, 40, 217, 0.08), 0 2px 8px rgba(109, 40, 217, 0.04);
}

.result-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.result-label {
    font-size: 13px;
    font-weight: 400;
    letter-spacing: -0.39px;
    color: #64748d;
    text-transform: uppercase;
}

.result-tag {
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.1px;
    line-height: 1.15;
    text-transform: uppercase;
    color: #4434d4;
    background: #b9b9f9;
    border-radius: 9999px;
    padding: 4px 8px;
}

.result-price-row {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 12px;
}

.result-original {
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.42px;
    font-feature-settings: "tnum";
    color: #64748d;
    text-decoration: line-through;
}

.result-final {
    font-size: 32px;
    font-weight: 400;
    letter-spacing: -0.64px;
    line-height: 1.1;
    font-feature-settings: "tnum";
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* ============================================================
   POPUP / PICKER OVERRIDES
   ============================================================ */
.category-search-box {
    padding: 8px 16px;
    background: #f6f9fc;
}

/* ============================================================
   LOADING
   ============================================================ */
.my-quotation-doubao /deep/ .van-loading {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ============================================================
   DIALOG — verification code
   ============================================================ */
.my-quotation-doubao /deep/ .van-dialog {
    overflow: visible;
    top: 65%;
    border-radius: 12px;
    border: 1px solid #e3e8ee;
}

.my-quotation-doubao /deep/ .van-dialog .logo-img {
    position: absolute;
    top: -220px;
    z-index: 2105;
    width: 320px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.my-quotation-doubao /deep/ .van-dialog .logo-title {
    font-family: Inter, "SF Pro Display", system-ui, sans-serif;
    font-size: 26px;
    font-weight: 300;
    letter-spacing: -0.26px;
    line-height: 1.12;
    color: #1c1e54;
    text-shadow: -1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;
}

/* ============================================================
   OVERLAY
   ============================================================ */
.my-quotation-doubao /deep/ .van-overlay {
    background-color: rgba(28,30,84,0.7);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    width: 100%;
    height: 100vh;
}

/* Dialog confirm button */
.my-quotation-doubao /deep/ .van-goods-action-button--danger {
    background: #533afd;
}

/* ============================================================
   RESPONSIVE
   ============================================================ */
@media screen and (min-width: 768px) {
    .mesh-hero {
        padding: 64px 32px 64px;
    }
    .hero-title {
        font-size: 32px;
        letter-spacing: -0.64px;
    }
    .quotation-content {
        padding: 24px;
        margin: -32px auto 0;
    }
    .btn-primary-pill {
        max-width: 320px;
    }
    .result-card {
        padding: 32px;
    }
}
</style>
